'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _parcels = require('parcels');

var _parcels2 = _interopRequireDefault(_parcels);

var _Types = require('parcels/lib/types/Types');

var _Types2 = _interopRequireDefault(_Types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (config) {
    (0, _Types2.default)('ParcelStateHock() expects param "config" to be', 'object')(config);

    var _config$initialValue = config.initialValue,
        initialValue = _config$initialValue === undefined ? function () {
        return undefined;
    } : _config$initialValue,
        prop = config.prop,
        _config$modify = config.modify,
        modify = _config$modify === undefined ? function (ii) {
        return ii;
    } : _config$modify,
        _config$debugRender = config.debugRender,
        debugRender = _config$debugRender === undefined ? false : _config$debugRender;


    (0, _Types2.default)('ParcelStateHock() expects param "config.initialValue" to be', 'function')(initialValue);
    (0, _Types2.default)('ParcelStateHock() expects param "config.prop" to be', 'string')(prop);
    (0, _Types2.default)('ParcelStateHock() expects param "config.modify" to be', 'function')(modify);
    (0, _Types2.default)('ParcelStateHock() expects param "config.debugRender" to be', 'boolean')(debugRender);

    return function (Component) {
        return function (_React$Component) {
            (0, _inherits3.default)(ParcelStateHock, _React$Component);

            function ParcelStateHock(props) {
                (0, _classCallCheck3.default)(this, ParcelStateHock);

                var _this = (0, _possibleConstructorReturn3.default)(this, (ParcelStateHock.__proto__ || (0, _getPrototypeOf2.default)(ParcelStateHock)).call(this, props));

                var parcel = new _parcels2.default({
                    // $FlowFixMe - props is not an unused function argument - this is only true for the default initialValue
                    value: initialValue(props),
                    handleChange: function handleChange(parcel) {
                        return _this.setState({ parcel: parcel });
                    },
                    debugRender: debugRender
                });

                _this.state = {
                    parcel: parcel
                };
                return _this;
            }

            (0, _createClass3.default)(ParcelStateHock, [{
                key: 'render',
                value: function render() {
                    var parcel = this.state.parcel;

                    if (modify) {
                        parcel = parcel.modify(modify);
                    }

                    var props = (0, _extends4.default)({}, this.props, (0, _defineProperty3.default)({}, prop, parcel));

                    return _react2.default.createElement(Component, props);
                }
            }]);
            return ParcelStateHock;
        }(_react2.default.Component);
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels-react/lib/ParcelStateHock.js
// module id = 731
// module chunks = 35783957827783